var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcIlustraCoaching(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "381px",
    height: "379px",
    viewBox: "0 0 381 379",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8C6ED634-1A21-42F8-81B4-DFFFE482717C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "06.1-coaching",
    transform: "translate(-832.000000, -230.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-ilustra-coaching",
    transform: "translate(832.000000, 231.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(72.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.52896101,207.5 C5.31245328,207.502843 3.30669454,208.403284 1.85420852,209.857833 C0.401979208,211.312125 -0.497152702,213.320348 -0.499999588,215.539 L-0.5,369.460322 C-0.497154249,371.679618 0.401975546,373.687846 1.85420392,375.142144 C3.30668902,376.596699 5.31244802,377.497148 7.52830504,377.5 L233.476734,377.5 C235.692787,377.496901 237.697824,376.596119 239.149357,375.14142 C240.600633,373.686978 241.49858,371.678793 241.5,369.460642 L241.5,215.539641 C241.499655,214.997793 241.435169,214.47515 241.033089,213.962509 C240.748674,213.599887 240.280035,213.232683 239.476635,212.885549 C238.234863,212.349002 236.120786,211.830077 232.517055,211.350177 C226.304358,210.522847 215.591025,209.791106 197.122457,209.194687 C164.384224,208.137449 107.244907,207.502505 7.52896101,207.5 Z",
    id: "Path",
    stroke: "#D8D8D8",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(120.500000, 298.500000) scale(-1, 1) translate(-120.500000, -298.500000) translate(9.000000, 220.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#A0616A",
    cx: 103.5,
    cy: 61.5,
    r: 28.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,119.912285 L86,125 C90.7140781,103.829856 91.8567212,84.051312 86,67 L121.700001,67 C119.760608,81.2083212 127.009549,99.8925216 137,119.912285 Z",
    id: "Path",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.984595,121.145017 C170.35878,133.330565 169.633052,145.317158 168.739063,157 L51.4024877,157 C50.0141353,149.286496 48.3260286,141.524116 46.3381676,133.712859 C45.0377493,128.665968 47.5815068,123.420808 52.3595791,121.296868 L56.1039158,119.636879 L89.1771434,105.000549 L89.566297,105.084325 L103.228941,107.995871 L127.319959,102 L127.740661,102.083776 L161.513301,108.964672 C162.511943,109.169925 163.480337,109.500737 164.395203,109.949156 C168.635976,112.040128 171.224944,116.438974 170.984595,121.145017 L170.984595,121.145017 Z",
    id: "Path",
    fill: "#1717CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189,157 L164.390056,157 L160,109 C171.608945,110.185999 181.133918,118.943822 183.548146,130.651558 L189,157 Z",
    id: "Path",
    fill: "#1717CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59,157 L34,157 L34.897704,148.51308 C35.1628398,135.469007 43.4651633,123.844986 55.977083,119 L56.0257386,119.644028 L59,157 Z",
    id: "Path",
    fill: "#1717CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.108913,45.6798098 C94.6973473,38.413933 107.302749,43.0561517 119.930072,62.8814384 L122.511628,84 C141.463069,65.8872241 140.505021,41.168994 119.252238,31.1153943 C117.162836,30.1270267 115.138094,29.0029019 112.864282,29.4001504 C103.034793,24.0899609 91.2832396,28.0783409 86.358398,36.583654 C82.4318403,37.2696877 76.8027367,45.1396919 77.0053181,49.1547701 L82.108913,45.6798098 Z",
    id: "Path",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#A0616A",
    cx: 117.5,
    cy: 62.5,
    rx: 3.5,
    ry: 4.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(120.500000, 84.500000) scale(-1, 1) translate(-120.500000, -84.500000) "
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.52896101,-0.5 C5.31245328,-0.497157373 3.30669454,0.403284365 1.85420852,1.85783323 C0.401979208,3.31212502 -0.497152702,5.32034825 -0.499999588,7.53899961 L-0.5,161.460322 C-0.497154249,163.679618 0.401975546,165.687846 1.85420392,167.142144 C3.30668902,168.596699 5.31244802,169.497148 7.52830504,169.5 L233.476734,169.5 C235.692787,169.496901 237.697824,168.596119 239.149357,167.14142 C240.600633,165.686978 241.49858,163.678793 241.5,161.460642 L241.5,7.53964119 C241.499655,6.9977929 241.435169,6.47515005 241.033089,5.96250875 C240.748674,5.59988665 240.280035,5.23268303 239.476635,4.88554888 C238.234863,4.34900245 236.120786,3.83007678 232.517055,3.35017669 C226.304358,2.52284695 215.591025,1.79110552 197.122457,1.19468737 C164.384224,0.137449086 107.244907,-0.497495226 7.52896101,-0.5 Z",
    id: "Path",
    stroke: "#D8D8D8",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#2F2E41",
    points: "174 110.011266 104.40498 126 75 70.3240426 134.509251 47"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FDA57D",
    cx: 115.5,
    cy: 79.5,
    r: 25.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.347835,163 L174,154.11195 C164.796681,137.476855 155.308021,122.315854 142.555685,124.010951 C131.210637,116.081562 130.55642,103.334682 133.425751,89 L102.566851,97.2378583 C105.282152,106.074153 104.231881,113.833187 97,119.823787 C107.104755,134.028893 113.644113,148.367595 112.347835,163 Z",
    id: "Path",
    fill: "#FDA57D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186,169 L88.7168749,169 C87.3382778,167.158537 85.872325,165.377516 84.3190166,163.656937 C84.2164789,163.537939 84.1082395,163.413301 84,163.294303 L86.6147791,126.527451 L86.8768407,122.81054 C87.0114289,120.86894 88.2776585,119.186047 90.1125843,118.510047 L90.118286,118.510047 C90.26431,118.448116 90.4147267,118.396978 90.5683126,118.357049 L98.6349088,116.215312 L99.4381312,116 L99.5520724,116.13598 L104.080982,121.36004 L107.105933,124.856004 L120.481849,140.295926 C122.907897,143.095747 126.356865,144.817054 130.063756,145.07805 L135.01422,145.423671 C143.775794,146.041247 149.979544,138.987071 149.979544,131.50224 C149.981738,128.873666 149.207173,126.302413 147.75213,124.108099 C147.389256,123.546926 146.985612,123.012895 146.544427,122.510277 L152.1728,123.411155 L160.23936,124.708693 L169.331354,145.967638 C178.468899,153.174792 184.239691,160.823927 186,169 Z",
    id: "Path",
    fill: "#1717CE"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FDA57D",
    points: "68.8409326 137 81 159.163127 74.1414508 165.597078 70.511399 169 39 169 57.8875648 148.743867"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193,169 L163.53167,169 L160.409284,155.660233 L153.753883,127.221823 L153.016893,124.072541 L153,124 L159.97047,124.418788 C167.900314,124.898185 174.916845,129.680479 178.215196,136.85394 L193,169 Z",
    id: "Path",
    fill: "#1717CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9163499,167 L105,157.008509 L94.745827,121.607511 C94.0600757,119.240067 91.7814731,117.728458 89.3692493,118.040727 L89.3692493,118.040727 C88.3815859,118.168583 87.4548597,118.595646 86.7100626,119.266159 L57,146.01287 C62.6836718,155.507588 68.7351571,155.74592 75.9163499,167 Z",
    id: "Path",
    fill: "#1717CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.661031,38.1606646 C131.661031,38.1606646 147.160486,41.0572569 150.74482,60.2629765 C151.305516,63.5018269 151.407683,66.8026579 151.048354,70.0696179 C150.690444,73.7665117 151.209619,81.574775 159.289062,90.7689187 C164.56092,96.7321749 169.473144,103.000023 174,109.539628 L174,109.539628 L157.804445,113.823225 L150.568306,87.1636054 C147.060055,74.2383976 141.655496,61.8968144 134.528497,50.5358891 L134.379723,50.2987299 C134.379723,50.2987299 129.000636,64.5785963 114.583234,66.5362156 L119.028609,60.7212784 C119.028609,60.7212784 102.174567,70.4012076 92.6258141,73.3582387 C90.4049867,74.0464094 88.7497432,75.8990018 88.3252873,78.1715023 C87.9008313,80.4440028 88.7768541,82.7632909 90.6013026,84.1972991 C90.6690258,84.2502176 90.7380008,84.3031776 90.8082274,84.356179 C97.8315534,89.6561529 112.159684,102.302404 106.499123,114.535957 C100.838562,126.76951 107.439662,129 107.439662,129 L95.2672514,124.399187 L89.6959566,122.028859 L90.2589189,126.121492 L63.0615159,126.687598 C63.0615159,126.687598 55.712073,126.643248 68.7667205,107.152113 C68.7667205,107.152113 71.9166978,99.8436978 69.3307051,94.2603236 C67.3475931,89.9786073 66.1190821,85.3796442 66.3160978,80.6703946 C67.1382535,61.0196485 75.4702037,21.0421108 131.661031,38.1606646 Z",
    id: "Path",
    fill: "#2F2E41"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(0.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.59152861,28.9561818 C1.93603987,40.1976656 -0.550063826,52.970223 0.898551889,65.2797799 C2.34716785,77.589339 7.7305044,89.4358965 16.8138919,98.8253791 C25.8972862,108.214869 37.5592946,113.988048 49.8146257,115.844228 C62.0699596,117.70041 74.9186172,115.639591 86.9054586,109.392146 C90.7748588,112.14509 100.088203,117.621477 109.431906,114.084585 L97.8443073,101.095794 C109.757709,90.1208286 116.5186,74.6620651 116.5,58.4792869 C116.494841,45.4151354 112.122192,33.1595109 104.600515,23.3079327 C97.0788369,13.4563514 86.40813,6.00881787 73.8068569,2.56122597 C61.2055767,-0.886367902 48.2294895,0.091625932 36.7398483,4.7418926 C25.250213,9.39215686 15.2470217,17.7146907 8.59152861,28.9561818 Z",
    id: "Path",
    stroke: "#D8D8D8",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FF6A58",
    x: 29,
    y: 47,
    width: 42,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E6E6E6",
    x: 29,
    y: 60,
    width: 73,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E6E6E6",
    x: 29,
    y: 74,
    width: 73,
    height: 4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(322.500000, 276.500000) scale(-1, 1) translate(-322.500000, -276.500000) translate(264.000000, 218.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.59152861,28.9561818 C1.93603987,40.1976656 -0.550063826,52.970223 0.898551889,65.2797799 C2.34716785,77.589339 7.7305044,89.4358965 16.8138919,98.8253791 C25.8972862,108.214869 37.5592946,113.988048 49.8146257,115.844228 C62.0699596,117.70041 74.9186172,115.639591 86.9054586,109.392146 C90.7748588,112.14509 100.088203,117.621477 109.431906,114.084585 L97.8443073,101.095794 C109.757709,90.1208286 116.5186,74.6620651 116.5,58.4792869 C116.494841,45.4151354 112.122192,33.1595109 104.600515,23.3079327 C97.0788369,13.4563514 86.40813,6.00881787 73.8068569,2.56122597 C61.2055767,-0.886367902 48.2294895,0.091625932 36.7398483,4.7418926 C25.250213,9.39215686 15.2470217,17.7146907 8.59152861,28.9561818 Z",
    id: "Path",
    stroke: "#D8D8D8",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FF6A58",
    x: 29,
    y: 47,
    width: 42,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E6E6E6",
    x: 29,
    y: 60,
    width: 73,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E6E6E6",
    x: 29,
    y: 74,
    width: 73,
    height: 4
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcIlustraCoaching);
export default __webpack_public_path__ + "static/media/ic-ilustra-coaching.037cd633a8d1acfdba69646b49076359.svg";
export { ForwardRef as ReactComponent };